import _SkipNext from "@mui/icons-material/SkipNext";
import _Forward from "@mui/icons-material/Forward10";
import _SkipPrevious from "@mui/icons-material/SkipPrevious";
import _Replay from "@mui/icons-material/Replay10";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ButtonContainer, DEFAULT_ICON_STYLES } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import { SIZES } from '@fupa/fupa-uikit';
import { PlaybackToggle } from 'app/components/tv/customControls/PlaybackToggle';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1vz75sn-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;z-index:9998;display:", ";font-size:", ";"], props => props.hide ? 'none' : 'flex', SIZES['28']);
const Container = styled.div.withConfig({
  componentId: "sc-1vz75sn-1"
})(["display:flex;align-items:center;justify-content:center;"]);
const SmallContainer = styled(Container).withConfig({
  componentId: "sc-1vz75sn-2"
})(["flex:1 20%;"]);
const BigContainer = styled(Container).withConfig({
  componentId: "sc-1vz75sn-3"
})(["flex:1 60%;"]);
export const MobileControls = _ref => {
  let {
    playerRef,
    playerReady,
    handlePreviousVideo,
    handleNextVideo,
    adPlaying,
    setHideAll,
    hide,
    isSeekable
  } = _ref;
  const [show, setShow] = useState('none');
  const longTouchTimer = useRef(null);
  const animationTimer = useRef(null);
  const bigContainerRef = useRef(null);
  const animateButton = useCallback(button => {
    if (animationTimer.current) {
      window.clearTimeout(animationTimer.current);
      animationTimer.current = null;
    }
    setShow(button);
    animationTimer.current = window.setTimeout(() => {
      setShow('none');
      animationTimer.current = null;
    }, 1000);
  }, []);

  // handle play/pause on touch for mobile devices
  useEffect(() => {
    const bigContainer = bigContainerRef.current;
    const player = playerRef.current;
    if (!bigContainer || !player || !playerReady) {
      return;
    }
    const handleTouchStart = e => {
      e.preventDefault();
      if (!player.paused()) {
        player.pause();
        longTouchTimer.current = window.setTimeout(() => {
          setHideAll(true);
          longTouchTimer.current = null;
        }, 500);
      }
    };
    bigContainer.addEventListener('touchstart', handleTouchStart);
    return () => {
      if (bigContainer) {
        bigContainer.removeEventListener('touchstart', handleTouchStart);
      }
    };
  }, [playerReady, animateButton]);

  // handle long-touch events
  useEffect(() => {
    const bigContainer = bigContainerRef.current;
    const player = playerRef.current;
    if (!bigContainer || !player || !playerReady) {
      return;
    }
    const handleTouchEnd = () => {
      if (longTouchTimer.current) {
        window.clearTimeout(longTouchTimer.current);
        longTouchTimer.current = null;
        animateButton('play');
        player.pause();
      } else {
        setHideAll(false);
        if (player.paused()) {
          player.play();
        } else {
          player.pause();
        }
        animateButton('play');
      }
    };
    bigContainer.addEventListener('touchend', handleTouchEnd);
    return () => {
      if (bigContainer) {
        bigContainer.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [playerReady, animateButton]);
  useEffect(() => {
    return () => {
      if (animationTimer.current) {
        window.clearTimeout(animationTimer.current);
        animationTimer.current = null;
      }
    };
  }, []);
  const handlePreviousClick = () => {
    animateButton('previous');
    handlePreviousVideo();
  };
  const handleNextClick = () => {
    animateButton('next');
    handleNextVideo();
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    hide: hide,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MobileControls",
    "data-sentry-source-file": "MobileControls.tsx"
  }, /*#__PURE__*/React.createElement(SmallContainer, {
    onClick: handlePreviousClick,
    "data-sentry-element": "SmallContainer",
    "data-sentry-source-file": "MobileControls.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    show: show === 'previous',
    title: "Vorherige Szene",
    bgColor: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "MobileControls.tsx"
  }, isSeekable ? /*#__PURE__*/React.createElement(_Replay, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  }) : /*#__PURE__*/React.createElement(_SkipPrevious, {
    style: DEFAULT_ICON_STYLES
  }))), /*#__PURE__*/React.createElement(BigContainer, {
    ref: bigContainerRef,
    "data-sentry-element": "BigContainer",
    "data-sentry-source-file": "MobileControls.tsx"
  }, /*#__PURE__*/React.createElement(PlaybackToggle, {
    playerRef: playerRef,
    playerReady: playerReady,
    adPlaying: adPlaying,
    bgColor: true,
    show: show === 'play',
    invert: true,
    "data-sentry-element": "PlaybackToggle",
    "data-sentry-source-file": "MobileControls.tsx"
  })), /*#__PURE__*/React.createElement(SmallContainer, {
    onClick: handleNextClick,
    "data-sentry-element": "SmallContainer",
    "data-sentry-source-file": "MobileControls.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    show: show === 'next',
    title: "N\xE4chste Szene",
    bgColor: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "MobileControls.tsx"
  }, isSeekable ? /*#__PURE__*/React.createElement(_Forward, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  }) : /*#__PURE__*/React.createElement(_SkipNext, {
    style: DEFAULT_ICON_STYLES
  }))));
};